export const ADD_ALL_PUBILC_SUBSCRIPTIONS = "ADD_ALL_PUBILC_SUBSCRIPTIONS";
export const REMOVE_ALL_PUBILC_SUBSCRIPTIONS =
    "REMOVE_ALL_PUBILC_SUBSCRIPTIONS";
export const EDIT_PUBILC_SUBSCRIPTION_BY_INDEX =
    "EDIT_PUBILC_SUBSCRIPTION_BY_INDEX";
export const REMOVE_PUBILC_SUBSCRIPTION_BY_INDEX =
    "REMOVE_PUBILC_SUBSCRIPTION_BY_INDEX";
